export const enum LEGEND_SHAPE {
  line = 'line',
  square = 'square',
  round = 'round',
}
interface LegendItem {
  label: string
  color: string
  type?: LEGEND_SHAPE
}
const CommonLegendList = ({ list }: { list: LegendItem[] }) => {
  return (
    <div className="text-12 mt-[12px] flex flex-wrap items-center justify-center gap-x-[16px] pb-[4px] text-gray-500">
      {list?.map((item, i) => (
        <div className="row-auto flex items-center gap-[8px]" key={`${item.label}`}>
          {item.type === LEGEND_SHAPE.line ? (
            <div className={`h-4 w-8 rounded-lg`} style={{ backgroundColor: item.color }} />
          ) : item.type === LEGEND_SHAPE.round ? (
            <div className={`mb-[3px] h-[8px] w-[8px] rounded-full border-[2px]`} style={{ borderColor: item.color }} />
          ) : (
            <div className={`h-[8px] w-[8px]`} style={{ backgroundColor: item.color }} />
          )}
          <div className="text-Sbody">{item.label}</div>
        </div>
      ))}
    </div>
  )
}

export default CommonLegendList
